<template>
  <div class="home_page">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'home' }">{{$t('header.homepage')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="brand_list">
      <div class="brand_category_list">
        <div class="brand_category_item" v-for="item in brandList" :key="item.initials">
          <span @click="jumpBrand(item.initials)"
                class="cursor-pointer">{{item.initials.toUpperCase()}}</span>
        </div>
      </div>
      <el-row v-for="item in brandList" :key="item.initials" class="brand">
        <el-col :span="2"
                class="brand_title"
                :id="item.initials.toUpperCase()">{{item.initials.toUpperCase()}}</el-col>
        <el-col :span="22">
          <el-col :span="4" v-for="it in item.brandList" :key="it.brandId">
            <div class="brand_item">
              <img src="http://www.plantmate.com/group1/M00/00/12/rBAAv16-Q_OIVsaXAABMcx-BLuQAAAAGACissYAAEzm239.jpg"
                   alt="" height="90px"
                   class="brand_item_img cursor-pointer"
                   @click="goBrandGoodList(it)">
              <div :title="it.name" class="ellipsis">{{it.name}}</div>
            </div>
          </el-col>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      brandList: []
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    getDataList () {
      this.$request.get(`/front/cross/commodity-user/app/category-quick-all-brand-list`)
        .then(data => {
          this.brandList = data || []
        })
    },
    // 跳转对应锚点
    jumpBrand (ele) {
      document.getElementById(ele).scrollIntoView()
    },
    // 跳转品牌商品列表页
    goBrandGoodList (brand) {
      this.$router.push({
        name: 'goodBrandCategoryList',
        query: {
          foregroundCategoryId: '',
          brandIdList: brand.brandId + '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.brand_list{
  .brand_category_list{
    background: #fff;
    line-height: 40px;
    .brand_category_item{
      display: inline-block;
      width: 40px;
      text-align: center;
    }
  }
  .brand{
    background: #fff;
    margin-top: 15px;
    .brand_title{
      padding: 24px;
      font-size: 24px;
    }
    .brand_item{
      width: 100%;
      margin: 10px auto 15px;
      text-align: center;
      .brand_item_img{
        height: 90px;
        padding: 15px;
      }
    }
  }
}
</style>
